import {
    Configuration,
    getConfig as _getConfig,
    getConfigByKey as _getConfigByKey,
} from '@tn/configs';

type GetUseRegionalConfigurationMethodsReturn = {
    getConfigByKey: ReturnType<typeof _getConfigByKey>;
    getConfig: ReturnType<typeof _getConfig>;
};

export const getUseRegionalConfigurationMethods = ({
    data,
}: {
    data?: Configuration;
}): GetUseRegionalConfigurationMethodsReturn => ({
    getConfigByKey: _getConfigByKey(data),
    getConfig: _getConfig(data),
});
